function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.04 16.498l-.711.734a4.917 4.917 0 01-7.107 0c-1.963-2.025-1.963-5.307 0-7.332l1.695-1.748a4.539 4.539 0 016.56 0l.273.282M9.46 3.002l.711-.734a4.917 4.917 0 017.107 0c1.963 2.025 1.963 5.307 0 7.332l-1.695 1.748a4.539 4.539 0 01-6.56 0l-.273-.282",
  strokeWidth: 1.5,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 20 20",
    stroke: "#D6D7E1"
  }, props), _ref);
};

export default SvgLink;